export default __webpack_public_path__ + "static/media/arrival8.04384bf6.png";